export default __webpack_public_path__ + "static/media/neurons.1b4ac07c.svg";